
export default {
    name: 'InfoseekNews',
    mounted() {
        if (this.$refs["script-holder"]) {
            let scriptEl = document.createElement('script');
            scriptEl.setAttribute('src', 'https://media.image.infoseek.co.jp/isnews/blogparts/index.min.js');
            scriptEl.setAttribute('class', 'rak-is-news-drawpoint');
            this.$refs["script-holder"].appendChild(scriptEl);
        }
    }
}

